import { scrollTo } from './scrollTo';

export function scrollToElement(elementId: string) {
  const promotionElement = document.getElementById(elementId);

  if (promotionElement) {
    scrollTo(promotionElement);
  }
}
